import { fetchWithAuth } from "./utils/ApiUtils";
import { config } from "./Constants";

// Price groups (#357): every product in a series, at or under one price. Premium only.
const BASE_URL = `${config.url}/api/v1/tracking-groups`;

const readData = async (response, fallbackMessage) => {
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(body.message || fallbackMessage);
    }
    return body.data;
};

export const TrackingGroupService = {
    getSeries: async () => (await readData(await fetchWithAuth(`${BASE_URL}/series`), 'Failed to load series')) || [],

    getGroups: async () => (await readData(await fetchWithAuth(BASE_URL), 'Failed to load price groups')) || [],

    // The products a group for this series covers (#361). The public products endpoint filters a
    // series by the same rule the pollers match a group with: the name contains it.
    getSeriesProducts: async (series) => {
        const response = await fetch(
            `${config.url}/api/v1/stocks?page=0&size=200&series=${encodeURIComponent(series)}`
        );
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
            throw new Error(body.message || 'Failed to load the products in this series');
        }
        return body.data?.content || [];
    },

    // One group per series: saving a series that already has a group changes its price.
    saveGroup: async (series, maxPrice) => readData(
        await fetchWithAuth(
            `${BASE_URL}?series=${encodeURIComponent(series)}&maxPrice=${encodeURIComponent(maxPrice)}`,
            { method: 'PUT' }
        ),
        'Failed to save the price group'
    ),

    deleteGroup: async (groupId) => readData(
        await fetchWithAuth(`${BASE_URL}/${groupId}`, { method: 'DELETE' }),
        'Failed to delete the price group'
    )
};
